import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from "@mui/material/IconButton";
import {Delete, Download, Visibility} from "@mui/icons-material";
import {Tooltip} from "@mui/material";
import {useState} from "react";
import {DownloadStudyNoteModal} from "./download-study-note-modal";

export const StudyNoteBasicCard = ({note, viewNote}) => {
    const [openDownloadModal, setOpenDownloadModal] = useState(false);

    return (
        <div style={{display: 'flex'}}>
            <Card sx={{maxWidth: 275, minWidth: 275}}>
                <CardContent>
                    {
                        note.title ?
                            <Typography sx={{mb: 1.5}} variant="h5" component="div">
                                {`${note.title}`}
                            </Typography>
                            :
                            null
                    }

                    <Typography sx={{mb: 1.5}} color="text">
                        {note.note.substring(0,30)}
                    </Typography>

                </CardContent>
                <CardActions sx={{display: "flex", flexDirection: "row-reverse", marginRight: "1rem"}}>
                    <Tooltip title={'Delete'}>
                        <IconButton color={"error"} size="small"><Delete/></IconButton>
                    </Tooltip>

                    <Tooltip title={'Download'}>
                        <IconButton onClick={() => setOpenDownloadModal(true)} color={"primary"} size="small"><Download/></IconButton>
                    </Tooltip>

                    <Tooltip title={'See full note details'}>
                        <IconButton onClick={() => viewNote(note)} color={"success"} size="small"><Visibility/></IconButton>
                    </Tooltip>
                </CardActions>
            </Card>

            <DownloadStudyNoteModal
                open={openDownloadModal}
                setOpen={() => setOpenDownloadModal(false)}
                note={note}
            />
        </div>
    );
}
